export default __webpack_public_path__ + "e9c4d90ffdfecc2c4bc23287a6e036dd.jpeg";